import React from "react";
import classNames from "classnames";
import Image from "theme/components/atoms/Image";

/**
 * @typedef {Omit<import("./Image").Props, "appearance" | "cover">} ImageProps
 */

/**
 * @typedef BackgroundImageProps
 * @property {string | boolean | number} backdrop
 */

/**
 * @type {React.FC<ImageProps & BackgroundImageProps>}
 */
const BackgroundImage = ({ backdrop, ...props }) => {
  return (
    <div
      className={classNames("background-image", {
        [`background-image--backdrop-${backdrop}`]: backdrop,
      })}
    >
      <Image {...props} appearance="full" cover />
    </div>
  );
};

export default BackgroundImage;
